import { render, staticRenderFns } from "./IconSolicitacao.vue?vue&type=template&id=d2547dbe"
import script from "./IconSolicitacao.vue?vue&type=script&lang=js"
export * from "./IconSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports